import React, { useState, useEffect } from 'react';
import { Form, Button, Row, Col, Alert } from 'react-bootstrap';
import moment from 'moment';
import { formatDouble } from '../helper/handler';

function Obiettivo730Form({ obiettivo, onSave, onClose }) {
    const [dataObiettivo, setDataObiettivo] = useState('');
    const [percentualeIncremento, setPercentualeIncremento] = useState('');
    const [dataDisponibilita, setDataDisponibilita] = useState('');
    const [errorMessage, setErrorMessage] = useState('');

    useEffect(() => {
        if (obiettivo) {
            setDataObiettivo(moment(obiettivo.dataObiettivo).format('YYYY-MM-DD'));
            setPercentualeIncremento(formatDouble(obiettivo.percentualeIncremento));
            setDataDisponibilita(moment(obiettivo.dataDisponibilita).format('YYYY-MM-DD'));
        }
    }, [obiettivo]);

    const handleSave = () => {
        if (!dataObiettivo) {
            setErrorMessage("La data obiettivo è obbligatoria.");
            return;
        }

        if (percentualeIncremento === '') {
            setErrorMessage("La percentuale rispetto al totale dell'anno precedente deve essere un numero valido.");
            return;
        }

        const sanitized = percentualeIncremento.replace(',', '.');

        if (!/^\d+(\.\d+)?$/.test(sanitized)) {
            setErrorMessage("La percentuale rispetto al totale dell'anno precedente deve essere un numero valido.");
            return;
        }

        const numericValue = parseFloat(sanitized);

        if (numericValue < 0) {
            setErrorMessage("La percentuale rispetto al totale dell'anno precedente deve essere un numero positivo.");
            return;
        }

        if (!dataDisponibilita) {
            setErrorMessage("La data di disponibilità è obbligatoria.");
            return;
        }

        const newObiettivo = {
            ...obiettivo,
            dataObiettivo: dataObiettivo,
            percentualeIncremento: percentualeIncremento,
            dataDisponibilita: dataDisponibilita
        };

        setErrorMessage('');
        onSave(newObiettivo);
    };

    return (
        <Form>
            {errorMessage && <Alert variant="danger">{errorMessage}</Alert>}
            <Row className="mb-3">
                <Col xs={12}>
                    <Form.Group>
                        <Form.Label>Data obiettivo</Form.Label>
                        <Form.Control id="dataObiettivo" name="dataObiettivo" type="date" value={dataObiettivo} onChange={(e) => setDataObiettivo(e.target.value)} />
                    </Form.Group>
                </Col>
            </Row>
            <Row className="mb-3">
                <Col xs={12}>
                    <Form.Group>
                        <Form.Label>Percentuale rispetto al totale dell'anno precedente (%)</Form.Label>
                        <Form.Control id="percentualeIncremento" name="percentualeIncremento" type="text" value={percentualeIncremento} onChange={(e) => setPercentualeIncremento(e.target.value)} />
                    </Form.Group>
                </Col>
            </Row>
            <Row className="mb-3">
                <Col xs={12}>
                    <Form.Group>
                        <Form.Label>Data disponibilità</Form.Label>
                        <Form.Control id="dataDisponibilita" name="dataDisponibilita" type="date" value={dataDisponibilita} onChange={(e) => setDataDisponibilita(e.target.value)} />
                    </Form.Group>
                </Col>
            </Row>
            <Button id="salvaObiettivo730" variant="primary" onClick={handleSave}>Salva</Button>
            <Button id="annullaObiettivo730" variant="secondary" onClick={onClose} className="ml-2">Annulla</Button>
        </Form>
    );
}

export default Obiettivo730Form;